import { render, staticRenderFns } from "./WindowTitleBar.vue?vue&type=template&id=0b578c5c&scoped=true&lang=html&"
import script from "./WindowTitleBar.vue?vue&type=script&lang=js&"
export * from "./WindowTitleBar.vue?vue&type=script&lang=js&"
import style0 from "./WindowTitleBar.vue?vue&type=style&index=0&id=0b578c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b578c5c",
  null
  
)

export default component.exports